import React from 'react'
import { Link } from 'react-router-dom'

const ListList = ({handleMenu}) => {
    return (
        <ul>
            <Link to="/" className='hvr-underline-from-center' onClick={handleMenu}>
                <li>Home</li>
            </Link>

            <Link to="/" className='hvr-underline-from-center' onClick={handleMenu}>
                <li>About</li>
            </Link>

            <Link to="/" className='hvr-underline-from-center' onClick={handleMenu}>
                <li>Services</li>
            </Link>


            <Link to="/list" className='hvr-underline-from-center' onClick={handleMenu}>
                <li>List Of House</li>
            </Link>

            <Link to="/" className='hvr-underline-from-center' onClick={handleMenu}>
                <li>Status</li>
            </Link>
        </ul>
    )
}

export default ListList